import { Link } from "gatsby";
import { navigate } from "gatsby-link";
import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 30px;
  font-weight: 500;
  flex-direction: column;
`;

const SubscriberOnlyText = styled.p`
  font-size: 14px;
`;

function StationLock({ user, subscriberOnly }) {
  return (
    <Wrapper>
      <br />
      {user ? (
        <>
          <Link
            to="/dashboard"
            state={{ defaultSection: "subscribe" }}
            class="button profile w-button"
          >
            🔒 Purchase a membership plan
          </Link>
          {subscriberOnly && (
            <SubscriberOnlyText>
              This station is for subscribers only
            </SubscriberOnlyText>
          )}
        </>
      ) : (
        <>
          <Link to="/registration" class="button profile w-button">
            🔒 Register for Free Trial
          </Link>
          <br />
          <Link to="/example" class="button-invert-colour w-button">
            FREE Example Stations
          </Link>
          <br />
          <Link to="/login" class="or-log-in">
            Already registered? Click to log in.
          </Link>
        </>
      )}
    </Wrapper>
  );
}

export default StationLock;
